import * as angular from "angular";
import {IController} from "angular";

export class taskPurposeIconCtrl implements IController {

  purpose: any;

  /* @ngInject */
  constructor() {}

  $onInit() {

  };

}
angular
  .module('bringoz.admin.tasks')
  .component('taskPurposeIcon', {
    bindings: {
      purpose: '<'
    },
    template: require('./task-purpose-icon.html').default,
    controller: taskPurposeIconCtrl
  });
